import { columns } from './columns'
import createState from '../_defaults/state'
import createGetters from '../_defaults/getters'
import createMutations from '../_defaults/mutations'
import createActions from '../_defaults/actions'

/* -------- CONFIG ----------- */
export const apiEndpoint = '/api/event'
export const namespace = 'event'
export const clientRoute = '/event'
export const dependencies = ['eventType', 'eventTeam', 'eventDiscount', 'eventDate', 'address', 'sponsorship', 'company', 'person', 'purchase', 'payment', 'question', 'questionOption', 'answer', 'personEvent', 'sponsorshipTitle', 'sponsorshipMedia']
export const params = {
  include: 'eventType,eventTeam,eventDiscount,eventDate,address,sponsorship,question[questionOption],sponsorshipTitle[sponsorshipMedia]'
}
/* --------------------------- */

/* -------- LABELS ----------- */
const titleColumn = 'name'
const subtitleColumn = 'eventDate'
const infoColumns = ['active', 'eventType']
/* --------------------------- */

const state = {
  defaultSort: '-id',
  defaultFilter: [{ key: 'active', value: { active: true } }],
  columns,
  apiEndpoint,
  namespace,
  dependencies,
  clientRoute,
  params,
  titleColumn,
  subtitleColumn,
  infoColumns
}

export default {
  namespaced: true,
  state: createState(Object.assign(state, { namespace })),
  getters: createGetters(),
  mutations: createMutations(),
  actions: createActions()
}
